<!-- <link rel="stylesheet" [href]="sanitizer.bypassSecurityTrustResourceUrl(scssUrl)"> -->

@if (this.displayHtml) {
<dx-data-grid
  [allowColumnReordering]="(dgProperties?.allowColumnReordering ?? false)"
  [allowColumnResizing]="(dgProperties?.allowColumnResizing ?? false)"
  [autoNavigateToFocusedRow]="(dgProperties?.autoNavigateToFocusedRow ?? false)"
  [cacheEnabled]="(dgProperties?.cacheEnabled ?? false)"
  [columnAutoWidth]="(dgProperties?.columnAutoWidth ?? false)"
  [columnHidingEnabled]="(dgProperties?.columnHidingEnabled ?? false)"
  [columnMinWidth]="dgProperties?.columnMinWidth"
  [dataSource]="(dgProperties?.remoteOperations ?? false) ? serverSideDataSource : clientSideProcessingModels"
  [height]="dgProperties?.height"
  [hoverStateEnabled]="(dgProperties?.hoverStateEnabled ?? false)"
  id="dataGrid"
  [focusedRowEnabled]="(dgProperties?.focusedRowEnabled ?? false)"
  [keyExpr]="(dgProperties?.remoteOperations ?? false) ? undefined : (dgProperties?.keyExpr ?? 'id')"
  [remoteOperations]="(dgProperties?.remoteOperations ?? false)"
  [showBorders]="(dgProperties?.showBorders ?? false)"
  [showColumnHeaders]="(dgProperties?.showColumnHeaders ?? false)"
  [showColumnLines]="(dgProperties?.showColumnLines ?? false)"
  [showRowLines]="(dgProperties?.showRowLines ?? false)"
  width="100%"
  (onCellClick)="onCellClick($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onContentReady)="onContentReady($event)"
  (onContextMenuPreparing)="onContextMenuPreparing($event)"
  (onInitialized)="onGridInitialized($event)"
  (onExporting)="onExporting($event)"
  (onEditingStart)="onEditingStart($event)"
  (onEditorPreparing)="onEditorPreparing($event)"
  (onInitNewRow)="onInitNewRow($event)"
  (onRowClick)="onRowClick($event)"
  (onRowDblClick)="onRowDblClick($event)"
  (onRowExpanding)="onRowExpanding($event)"
  (onRowInserting)="onRowInserting($event)"
  (onRowInserted)="onRowInserted($event)"
  (onRowPrepared)="onRowPrepared($event)"
  (onRowUpdating)="onRowUpdating($event)"
  (onRowUpdated)="onRowUpdated($event)"
  (onRowRemoving)="onRowRemoving($event)"
  (onRowRemoved)="onRowRemoved($event)"
  (onSelectionChanged)="onSelectionChanged($event)"
  (onTabChange)="onTabChange($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)"
>
  <dxo-load-panel
  [enabled]="(dgProperties?.loadPanel ?? false)"
  [text]="(dgProperties?.loadPanelText ?? '')"
  [showIndicator]="(dgProperties?.loadPanelShowIndicator ?? false)"
  [showPane]="(dgProperties?.loadPanelShowPane ?? false)"
  ></dxo-load-panel>

  <dxo-search-panel
    [highlightSearchText]="(dgProperties?.highlightSearchText ?? false)"
    id="search-panel"
    name="search-panel"
    [searchVisibleColumnsOnly]="(dgProperties?.searchVisibleColumnsOnly ?? false)"
    [visible]="(dgProperties?.searchPanel ?? false)"
    [width]="(dgProperties?.searchPanelWidth ?? gridSearchPanelWidthPx)"
  ></dxo-search-panel>

  <dxo-column-chooser
    [enabled]="(dgProperties?.columnChooser ?? false)"
    [mode]="(dgProperties?.columnChooserMode ?? 'select')"
    [sortOrder]="dgProperties?.columnChooserSort || gridColumnChooserSort==true ? 'asc' : undefined"
  >
    <dxo-position
      my="top right"
      at="bottom right"
      of=".dx-datagrid-column-chooser-button"
      collision="fit"
    ></dxo-position>
  </dxo-column-chooser>
  
  <dxo-state-storing
    [enabled]="gridRememberColumns"
    type="custom"
    [customLoad]="stateStoringLoad"
    [customSave]="stateStoringSave"
    [savingTimeout]="1000"
  ></dxo-state-storing>

  <dxo-export
    [allowExportSelectedData]="(dgProperties?.allowExportSelectedData ?? false)"
    [enabled]="(dgProperties?.export ?? false)"
    [formats]="dgProperties?.exportFormat"
  ></dxo-export>

  <dxo-selection
    [mode]="dgProperties?.selectionMode"
    [showCheckBoxesMode]="dgProperties?.selectionCheckBoxMode"
  ></dxo-selection>

  <dxo-header-filter
    [visible]="(dgProperties?.headerFilter ?? false) && filterRowVisible"
  ></dxo-header-filter>

  <dxo-filter-row
    [visible]="filterRowVisible"
  ></dxo-filter-row>
  
  <dxo-scrolling
    [mode]="dgProperties?.scrollingMode"
    [showScrollbar]="dgProperties?.showScrollbar ? 'always' : 'never'"
    [useNative]="false"
  ></dxo-scrolling>
  
  <dxo-row-dragging
    [allowReordering]="(dgProperties?.rowDraggingAllowReordering ?? false)"
    [onReorder]="onReorder"
    [showDragIcons]="(dgProperties?.rowDraggingShowDragIcons ?? false)"
  ></dxo-row-dragging>

  <dxo-column-fixing
    [enabled]="(dgProperties?.columnFixing ?? false)"
  ></dxo-column-fixing>

  <dxo-editing
    [allowAdding]="(dgActionColumn?.visible ?? false) && (dgActionColumn?.allowAdding ?? false)"
    [allowDeleting]="(dgActionColumn?.visible ?? false) && (dgActionColumn?.allowDeleting ?? false)"
    [allowUpdating]="(dgActionColumn?.visible ?? false) && (dgActionColumn?.allowUpdating ?? false)"
    [mode]="dgActionColumn?.mode ?? 'popup'"
    [useIcons]="dgActionColumn?.useIcons ?? true"
    [updateIcon]="dgActionColumn?.updateIcon"
  >
    <dxo-popup
      [disabled]="dgPopup?.disabled"
      [dragOutsideBoundary]="dgPopup?.dragOutsideBoundary"
      [height]="dgPopup?.height"
      [hideOnOutsideClick]="dgPopup?.hideOnOutsideClick"
      [shading]="dgPopup?.shading"
      [showCloseButton]="dgPopup?.showCloseButton"
      [showTitle]="dgPopup?.showTitle"
      [title]="dgPopup?.title"
      [toolbarItems]="dxoPopupButtonItems"
      [width]="dgPopup?.width"
    ></dxo-popup>
  </dxo-editing>

  <dxo-toolbar>
    @if (toolbarStartTemplate) {
      <dxi-item location="before" locateInMenu="auto">
        <div *dxTemplate>
          <ng-container *ngTemplateOutlet="toolbarStartTemplate"></ng-container>
        </div>
      </dxi-item>
    }

    @if (this.dgProperties?.showTabs) {
    <dxi-item location="before" locateInMenu="auto">
      <div *dxTemplate>
        <ul ngbNav #ArrowNgbNav_Log="ngbNav"
          [(activeId)]="activeId"
          class="nav nav-pills arrow-navtabs nav-success bg-light mb-0"
          (shown)="onTabChange($event)"
        >

        @for(tab of dgTabs; track tab) {
          <li [ngbNavItem]="tab.id">
            <a ngbNavLink>
              <span class="d-sm-block">{{tab.name}}</span>
            </a>
          </li>
        }
        </ul>
        <div class="tab-content">
          <div [ngbNavOutlet]="ArrowNgbNav_Log"></div>
        </div>  
        </div>
      </dxi-item>
    }
  
    @if (this.dgProperties?.checkbox0?.visible) {
      <dxi-item location="before" locateInMenu="auto" cssClass="gv-toolbar-hideable">
        <div *dxTemplate>
          <div class="d-flex align-items-center gap-1" style="margin-left: 12px;">
            <div class="form-check form-switch form-switch-md mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                [checked]="dgProperties?.checkbox0?.value === dgProperties?.checkbox0?.onValue"
                (change)="checkbox0Change.emit($any($event.target).checked ? dgProperties?.checkbox0?.onValue : dgProperties?.checkbox0?.offValue)"
              />
            </div>
            <span class="text-muted small">{{dgProperties?.checkbox0?.title}}</span>
          </div>
        </div>
      </dxi-item>
    }

    @if (this.dgProperties?.showAddButton) {
      @if (this.dgProperties?.useDevExtremePopupForm) {
        <dxi-item name="addButton"></dxi-item>
      }
    }

    @if (this.dgProperties?.export) {
      <dxi-item name="exportButton"></dxi-item>
    }

    @if (this.dgProperties?.columnChooser) {
      <dxi-item name="columnChooserButton"></dxi-item>
    }
    
    @if (this.dgProperties?.searchPanel) {
      <dxi-item name="searchPanel"></dxi-item>
    }
  </dxo-toolbar>

  <div *dxTemplate="let data of 'userDefinedColumnsTemplate'">
    @if (isUserDefinedColumns) {
      <div class="d-flex align-items-center gap-2 gv-user-defined-columns">
        <span class="text-muted small">User defined columns</span>
        <button
          type="button"
          class="btn btn-sm btn-light gv-restore-columns-btn"
          [ngbTooltip]="showTooltips ? 'Restore the default columns' : null"
          placement="bottom"
          tooltipClass="custom-tooltip-success"
          triggers="hover"
          (click)="restoreColumns()"
        >
          Restore columns
        </button>
      </div>
    }
  </div>

  <div *dxTemplate="let data of 'additionalFiltersTemplate'">
    <button
      #additionalFiltersTooltip="ngbTooltip"
      [attr.aria-expanded]="additionalFiltersVisible"
      class="grid-filter-toggle-btn gv-additional-filters-btn"
      [class.active]="additionalFiltersActive"
      [ngbTooltip]="showTooltips ? 'Additional Filters' : null"
      placement="bottom"
      tooltipClass="custom-tooltip-success"
      triggers="hover"
      type="button"
      (click)="additionalFiltersTooltip.close(); openAdditionalFilters($event.currentTarget)"
    >
      <i class="dx-icon dx-icon-filter"></i>
    </button>
  </div>

  <div *dxTemplate="let data of 'filterRowToggleTemplate'">
    <button
      #filterToggleTooltip="ngbTooltip"
      type="button"
      class="grid-filter-toggle-btn"
      [class.active]="filterRowVisible"
      [attr.aria-pressed]="filterRowVisible"
      [ngbTooltip]="showTooltips ? (filterRowVisible ? 'Hide Filters' : 'Show Filters') : null"
      placement="bottom"
      tooltipClass="custom-tooltip-success"
      triggers="hover"
      (click)="filterToggleTooltip.close(); toggleFilterRow()"
    >
      <i class="dx-icon dx-icon-filter"></i>
    </button>
  </div>

  @for(column of dgColumns; track column) {
          <!-- This will use the displayCurrency function that allows different currency symbols per row, but it will stop the column total from working as the cell will then be a string rather than a number
               [calculateCellValue]= "column.dataType=='currency' ? displayCurrency : undefined"
               [format]="column.dataType=='datetime' ? 'dd/MM/yyyy HH:mm:ss' : undefined" -->
    <dxi-column
      [alignment]="column.alignment"
      [allowFiltering]="column.allowFiltering"
      [allowFixing]="column.allowFixing"
      [allowSearch]="column.allowSearch"
      [allowSorting]="column.allowSorting"
      [autoWidth]="column.autoWidth"
      [calculateCellValue]="column.calculateCellValue"
      [calculateDisplayValue]="column.calculateDisplayValue"
      [calculateSortValue]="column.calculateSortValue"
      [caption]="column.caption"
      [cellTemplate]="column.cellTemplate"
      [customizeText]="column.customizeText"
      [dataField]="column.dataField"
      [dataType]="column.dataType"
      [falseText]="column.falseText"
      [filterValue]="column.filterValue"
      [filterValues]="column.filterValues"
      [fixedPosition]="column.fixedPosition"
      [format]="column.format != undefined ? column.format
                                           : column.dataType=='date' ? 'dd/MM/yyyy'
                                                                     : column.dataType=='datetime' ? 'dd/MM/yyyy HH:mm:ss'
                                                                                                   : column.dataType=='currency' ? { style: 'currency', currency: 'GBP', precision: 2 }
                                                                                                                                 : column.dataType=='decimal' ? { style: 'decimal', precision: 2 }
                                                                                                                                                              : undefined"
      [headerFilter]="column.headerFilter"
      [hidingPriority]="column.hidingPriority"
      [minWidth]="column.minWidth"
      [selectedFilterOperation]="column.selectedFilterOperation"
      [setCellValue]="column.setCellValue"
      [showInColumnChooser]="column.showInColumnChooser"
      [sortIndex]="column.sortIndex"
      [sortOrder]="column.sortOrder"
      [trueText]="column.trueText"
      [visible]="column.gridVisible"
      [visibleIndex]="column.visibleIndex"
      [width]="column.width"
    >
      @if(column.dataSource) {
        <dxo-lookup
          [dataSource]="column.dataSource"
          [displayExpr]="column.dataSourceDisplayField"
          [valueExpr]="column.dataSourceLookupField">
        </dxo-lookup>
      }
      <dxo-form-item
        [colSpan]="dgPopup?.colSpan"
        [helpText]="dgPopup?.helpText"
        [id]="column.dataField"
        [name]="column.dataField"
        [visible]="column.formVisible"
      >        
        <dxo-label
          [for]="column.dataType"
          [location]="(dgPopup?.labelLocation ?? 'top')"
          [showColon]="(dgPopup?.showColon ?? false)"
          [text]="column.caption"
          [visible]="column.formVisible"
        ></dxo-label>
        @for(rule of column.formValidationRules; track rule) {
          <dxi-validation-rule
            [type]="rule.rule"
            [message]="getValidationRuleMessage(rule)"
            [min]="rule.min!=undefined ? rule.min : ''"
            [max]="rule.max!=undefined ? rule.max : ''"
          ></dxi-validation-rule>
        }
      </dxo-form-item>
    </dxi-column>  
  }
  
  @if (dgActionColumn?.visible) {
    <dxi-column
      [caption]="dgActionColumn?.caption"
      [cellTemplate]="dgActionColumn?.cellTemplate"
      [fixed]="dgActionColumn?.fixed"
      [fixedPosition]="dgActionColumn?.fixedPosition"
      type="buttons"
      [visible]="dgActionColumn?.visible"
      [minWidth]="dgActionColumn?.minWidth"
      [width]="dgActionColumn?.width"
      [showInColumnChooser]="dgActionColumn?.showInColumnChooser"
    >
      @if(this.dgProperties?.useDevExtremePopupForm) {
        <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover edit-icon' : ''" name="edit"></dxi-button>
        <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover delete-icon' : ''" name="delete"></dxi-button>
      } @if(gridShowButtons) {

        @if (dgActionColumn?.allowUpdating) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover edit-icon' : ''" [icon]="dgActionColumn?.updateIcon" [onClick]="editRow" [visible]="updateButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowUpdating && dgActionColumn?.allowDeleting) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png" [visible]="updateButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowDeleting) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover delete-icon' : ''" [disabled]="deleteButtonDisabled" [icon]="dgActionColumn?.deleteIcon" [onClick]="deleteRow" [visible]="deleteButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowUndelete) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover' : ''" [disabled]="undeleteButtonDisabled" [icon]="dgActionColumn?.undeleteIcon" [onClick]="undeleteRow" [visible]="undeleteButtonVisible"></dxi-button>
        }
  <!-- moreRow one -->
        @if ((dgActionColumn?.allowUpdating || dgActionColumn?.allowDeleting) && dgActionColumn?.allowMore) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png" [visible]="moreButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowMore) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover' : ''" [icon]="dgActionColumn?.moreIcon" [onClick]="moreRow" [visible]="moreButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowRisk && (dgActionColumn?.allowUpdating || dgActionColumn?.allowDeleting || dgActionColumn?.allowMore)) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png"></dxi-button>
        }

        @if (dgActionColumn?.allowRisk) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover' : ''" icon="assets/images/_suresim/Button Riskline 55x23.png" [onClick]="riskRow" [visible]="riskButtonVisible"></dxi-button>
          <!-- CRN_20260522 - invisible 55x23 placeholder for button alignment -->
          <dxi-button icon="assets/images/_suresim/Button Spacer 55x23.png" [visible]="riskButtonHidden"></dxi-button>
        }

        @if (dgActionColumn?.allowLocation && (dgActionColumn?.allowUpdating || dgActionColumn?.allowDeleting || dgActionColumn?.allowMore || dgActionColumn?.allowRisk)) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png"></dxi-button>
        }

        @if (dgActionColumn?.allowLocation) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover' : ''" [icon]="dgActionColumn?.locationIcon" [onClick]="locationRow" [visible]="locationButtonVisible"></dxi-button>
          <dxi-button icon="assets/images/_suresim/Button Spacer 55x23.png" [visible]="locationButtonHidden"></dxi-button>
        }

        @if (dgActionColumn?.allowMessage && (dgActionColumn?.allowUpdating || dgActionColumn?.allowDeleting || dgActionColumn?.allowMore || dgActionColumn?.allowRisk || dgActionColumn?.allowLocation)) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png"></dxi-button>
        }

        @if (dgActionColumn?.allowMessage) {
          <dxi-button [cssClass]="(gridButtonsOnHoverGrow ? 'grow-on-hover ' : '') + 'grid-action-message-btn'" [icon]="dgActionColumn?.messageIcon" [onClick]="messageRow" [visible]="messageButtonVisible"></dxi-button>
        }

        @if (dgActionColumn?.allowStatement && (dgActionColumn?.allowUpdating || dgActionColumn?.allowDeleting || dgActionColumn?.allowMore || dgActionColumn?.allowRisk || dgActionColumn?.allowLocation || dgActionColumn?.allowMessage)) {
          <dxi-button icon="assets/images/_suresim/Button Spacer 5x23.png"></dxi-button>
        }

        @if (dgActionColumn?.allowStatement) {
          <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover' : ''" [icon]="dgActionColumn?.statementIcon" [onClick]="statementRow" [visible]="statementButtonVisible"></dxi-button>
          <!--CRN_20260728 - invisible 55x23 placeholder for button alignment-->
          <dxi-button icon="assets/images/_suresim/Button Spacer 55x23.png" [visible]="statementButtonHidden"></dxi-button>
        }
  <!-- moreRow one -->

  <!-- moreRow two -->
        <!-- @if (dgActionColumn?.allowMore) {
          <dxi-button template="moreRowTemplate"></dxi-button>
        }
        
        <span *dxTemplate="let d of 'moreRowTemplate'">
          <span class="btn-group" role="group" ngbDropdown>
            <button id="moreRowBtn" type="button" class="border-0 bg-transparent" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
              <img src="assets/images/_suresim/Button More 55x23.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1" ngbDropdownMenu>
              <li><a class="dropdown-item" href="javascript:void(0);">Dropdown link</a></li>
              <li><a class="dropdown-item" href="javascript:void(0);">Dropdown link</a></li>
            </ul>
          </span>
        </span> -->
  <!-- moreRow two -->
      } @else {
        <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover edit-icon' : ''" name="edit" [onClick]="editRow"></dxi-button>
        <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover delete-icon' : ''" name="delete" [onClick]="deleteRow"></dxi-button>
      }
    </dxi-column>
  }

  @for(column of dgColumns; track column) {
    @if (column.cellTemplate != undefined) {
      @if (column.cellTemplateType=="avatar") {
        <div *dxTemplate="let data of column.cellTemplate">
          <span class="dg-avatar-cell">
            <span class="dg-avatar" [style.background-color]="getAvatarColor(data.value)">{{getInitials(data.value)}}</span>
            <span class="dg-avatar-label" [class.dg-avatar-link]="column.avatarClickable">{{data.value}}</span>
          </span>
        </div>
      }
      @if (column.cellTemplateType=="avatarPhoto") {
        <div *dxTemplate="let data of column.cellTemplate">
          <span class="dg-avatar-cell">
            @if (hasAvatarPhoto(data.data, column) && getAvatarPhotoObjectUrl(data.data, column)!="") {
              <img class="dg-avatar dg-avatar-img" [src]="getAvatarPhotoObjectUrl(data.data, column)" alt="" />
            } @else {
              <span class="dg-avatar" [style.background-color]="getAvatarColor(data.value)">{{getInitials(data.value)}}</span>
            }
            <span class="dg-avatar-label" [class.dg-avatar-link]="column.avatarClickable">{{data.value}}</span>
          </span>
        </div>
      }
      @if (column.cellTemplateType == "conditional") {
        <div *dxTemplate="let data of column.cellTemplate">
          @if (column.cellTemplateCondition != undefined && (column.cellTemplateCondition(data.data) == true)) {
            <span>{{data.value}}</span>
          } @else {
            <span></span>
          }
        </div>
      }
      @if (column.cellTemplateType=="countBadge") {
        <div *dxTemplate="let data of column.cellTemplate">
          <span class="dg-count-badge">
            <span class="dg-count-num" [class.has]="(data.value ?? 0) > 0">{{ data.value ?? 0 }}</span>
            <span class="dg-count-label">{{ (data.value ?? 0) === 0 ? 'Not used yet' : ((data.value ?? 0) === 1 ? '1 rule' : (data.value + ' rules')) }}</span>
          </span>
        </div>
      }
      @if (column.cellTemplateType == "iconAndValue") {
        <div *dxTemplate="let data of column.cellTemplate">
          @if (getCellIcon(column, data.data); as cellIcon) {
            <i class="{{cellIcon.iconClass}} {{cellIcon.colourClass}} cell-icon align-middle me-1" container="body" [ngbTooltip]="cellIcon.tooltip ?? ''"></i>
          }
          <span class="align-middle">{{data.value}}</span>
        </div>
      }
      @if (column.cellTemplateType=="iconButton") {
        <div *dxTemplate="let data of column.cellTemplate">
          @if (column.cellTemplateCondition==undefined || (column.cellTemplateCondition(data.data)==true)) {
            <img alt="" [src]="column.cellTemplateIcon" style="cursor:pointer;" />
          }
        </div>
      }
      @if (column.cellTemplateType == "imageAndValue") {
        <div *dxTemplate="let data of column.cellTemplate">
          <img
            alt=""
            width="16"
            [src]="getImage(data.data, column.imageColumn)"
          />
          <span> {{data.value}}</span>
        </div>
      }
      @if (column.cellTemplateType == "link") {
        <div *dxTemplate="let data of column.cellTemplate">
          @if (getCellIcon(column, data.data); as cellIcon) {
            <i class="{{cellIcon.iconClass}} {{cellIcon.colourClass}} cell-icon align-middle me-1" container="body" [ngbTooltip]="cellIcon.tooltip ?? ''"></i>
          }
          @if (column.cellTemplateCondition != undefined && (column.cellTemplateCondition(data.data) == true)) {
            <span [ngClass]="{ 'text-secondary': true }">{{data.value}}</span>
          } @else {
            <span>{{data.value}}</span>
          }
        </div>
      }
    }
  }

  @if (dgActionColumn?.allowDeleting || dgActionColumn?.allowUpdating || dgActionColumn?.allowMore || dgActionColumn?.allowStatement) {
    @if (dgActionColumn?.cellTemplate == "DataDrivenButtons") {
    <div *dxTemplate="let data of 'DataDrivenButtons'" style="padding-right: 8px;">
    @if(this.dgProperties?.useDevExtremePopupForm) {
      <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover edit-icon' : ''" name="edit"></dxi-button>
      <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover delete-icon' : ''" name="delete"></dxi-button>
    } @if(gridShowButtons) {

      @if (dgActionColumn?.allowRisk && dgActionColumn?.riskRowButtonCondition(data.data) == true) {
        <button type="button"
                class="btn btn-soft-warning btn-sm grid-action-risk-btn"
                (click)="onImageClick('riskButton', data)"
        >Riskline</button>
        @if (dgActionColumn?.allowUpdating) {
          <img alt="Missing Spacer" src="assets/images/_suresim/Button Spacer 5x23.png" />
        }
      }

      @if (dgActionColumn?.allowStatement && dgActionColumn?.statementRowButtonCondition(data.data) == true) {
        <img alt="Missing Button"
          [src]="dgActionColumn?.statementIcon"
          (click)="onImageClick('statementButton', data)"
        />
        @if (dgActionColumn?.allowUpdating) {
          <img alt="Missing Spacer" src="assets/images/_suresim/Button Spacer 5x23.png" />
        }
      }

      @if (dgActionColumn?.allowUpdating) {
        <img *ngIf="dgActionColumn?.updateRowButtonCondition(data.data) == true"
          alt="Missing Button"
          [src]="dgActionColumn?.updateIcon"
          (click)="onImageClick('updateButton', data)"
        />
      }

      @if (dgActionColumn?.allowDeleting) {
        <img *ngIf="dgActionColumn?.deleteRowButtonCondition(data.data) == true &&
                    dgActionColumn?.updateRowButtonCondition(data.data) == true"
          alt="Missing Spacer"
          src="assets/images/_suresim/Button Spacer 5x23.png"
        />
      }

      @if (dgActionColumn?.allowDeleting) {
        <img *ngIf="dgActionColumn?.deleteRowButtonCondition(data.data) == true &&
                    !(dgActionColumn?.allowUndelete && dgActionColumn?.undeleteRowButtonCondition(data.data) == true)"
          alt="Missing Button"
          class="has-ngb-tooltip"
          container="body"
          [ngbTooltip]="deleteButtonHint({ row: { data: data.data } }) || null"
          placement="bottom auto"
          [src]="dgActionColumn?.deleteIcon"
          tooltipClass="custom-tooltip-success"
          (click)="onImageClick('deleteButton', data)"
        />
      }

      @if (dgActionColumn?.allowUndelete) {
        <img *ngIf="dgActionColumn?.undeleteRowButtonCondition(data.data) == true"
          alt="Missing Button"
          class="has-ngb-tooltip"
          [class.dx-state-disabled]="undeleteButtonDisabled({ row: { data: data.data } })"
          container="body"
          [ngbTooltip]="undeleteButtonHint({ row: { data: data.data } }) || null"
          placement="bottom auto"
          [src]="dgActionColumn?.undeleteIcon"
          tooltipClass="custom-tooltip-success"
          (click)="onImageClick('undeleteButton', data)"
        />
      }

<!-- moreRow one -->
      @if (dgActionColumn?.allowMore) {
        <img *ngIf="dgActionColumn?.moreRowButtonCondition(data.data) == true &&
                   (dgActionColumn?.updateRowButtonCondition(data.data) == true || 
                    dgActionColumn?.deleteRowButtonCondition(data.data) == true)"
          alt="Missing Spacer"
          src="assets/images/_suresim/Button Spacer 5x23.png"
        />
      }

      @if (dgActionColumn?.allowMore) {
        <img *ngIf="dgActionColumn?.moreRowButtonCondition(data.data) == true"
          alt="Missing Button"
          [src]="dgActionColumn?.moreIcon"
          (click)="onImageClick('moreButton', data)"
        />
      }
<!-- moreRow one -->

<!-- moreRow two -->
      <!-- @if (dgActionColumn?.allowMore) {
        <dxi-button template="moreRowTemplate"></dxi-button>
      }
      
      <span *dxTemplate="let d of 'moreRowTemplate'">
        <span class="btn-group" role="group" ngbDropdown>
          <button id="moreRowBtn" type="button" class="border-0 bg-transparent" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
            <img src="assets/images/_suresim/Button More 55x23.png">
          </button>
          <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1" ngbDropdownMenu>
            <li><a class="dropdown-item" href="javascript:void(0);">Dropdown link</a></li>
            <li><a class="dropdown-item" href="javascript:void(0);">Dropdown link</a></li>
          </ul>
        </span>
      </span> -->
<!-- moreRow two -->
    } @else {
      <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover edit-icon' : ''" name="edit" [onClick]="editRow"></dxi-button>
      <dxi-button [cssClass]="gridButtonsOnHoverGrow ? 'grow-on-hover delete-icon' : ''" name="delete" [onClick]="deleteRow"></dxi-button>
    }
        </div>
      }
  }
 
  <dxo-master-detail [enabled]="(this.dgProperties?.masterDetail ?? false)" template="detail"></dxo-master-detail>
  
  <div *dxTemplate="let employee of 'detail'">
    <div class="row">
      <div class="col-6">
        @if(this.dgProperties?.masterDetailCaption1Show) {
          <div class="mb-3">
            <div class="master-detail-caption"><strong>{{this.dgProperties?.masterDetailCaption1}}</strong></div>
          </div>
        }
      </div>
      <div class="col-6">
        @if(this.dgProperties?.masterDetailCaption2Show) {
          <div class="mb-3">
            <div class="master-detail-caption"><strong>{{this.dgProperties?.masterDetailCaption2}}</strong></div>
          </div>
        }
      </div>
    </div>
    <ng-content></ng-content>
  </div>

  <dxo-summary>
    @for(column of dgColumns; track column) {
      @if(column.summaryType && column.summaryType != "none") {
        <dxi-total-item
          [column]="column.dataField"
          [summaryType]="column.summaryType"
          [valueFormat]="column.summaryValueFormat != undefined ? column.summaryValueFormat
                                                                : column.dataType=='date' ? 'dd/MM/yyyy'
                                                                                          : column.dataType=='datetime' ? 'dd/MM/yyyy HH:mm:ss'
                                                                                                                        : column.dataType=='currency' ? { style: 'currency', currency: 'GBP', precision: 2 }
                                                                                                                                                      : column.dataType=='decimal' ? { style: 'decimal', precision: 2 }
                                                                                                                                                                                   : undefined"
          [displayFormat]="'{0}'"
        ></dxi-total-item>
      }
    }
  </dxo-summary>

  <dxo-paging
    [enabled]="(dgProperties?.paging ?? false)"
    [pageSize]="(dgProperties?.pageSize ?? 15)"
  ></dxo-paging>

  <dxo-pager
    [allowedPageSizes]="dgProperties?.allowedPageSizes"
    [displayMode]="(dgProperties?.pagerDisplayMode ?? 'adaptive')"
    [showInfo]="(dgProperties?.pagershowInfo ?? false)"
    [showPageSizeSelector]="(dgProperties?.showPageSizeSelector ?? false)"
    [visible]="(dgProperties?.pagerVisible ?? false)"
  ></dxo-pager>
</dx-data-grid>
}

@if (hasAdditionalFilters) {
  <dx-popup
    [dragEnabled]="false"
    height="auto"
    [hideOnOutsideClick]="additionalFiltersHideOnOutsideClick"
    [position]="additionalFiltersPosition"
    [shading]="false"
    [showCloseButton]="true"
    [showTitle]="true"
    title="Additional Filters"
    [(visible)]="additionalFiltersVisible"
    width="250"
    [wrapperAttr]="additionalFiltersWrapperAttr"
  >
    <div *dxTemplate="let data of 'content'" class="gv-additional-filters-list">
      @if (dgProperties?.checkbox1?.visible) {
        <div class="gv-additional-filters-item">
          <dx-check-box
            [text]="dgProperties?.checkbox1?.title ?? ''"
            [value]="includeCeasedChecked"
            (onValueChanged)="additionalFiltersCheckbox1Changed($event)"
          ></dx-check-box>
        </div>
      }
      @if (showCeasedFilters) {
        <div class="gv-additional-filters-item">
          <dx-check-box
            text="Include - Ceased"
            [disabled]="additionalFilters.onlyCeased"
            [value]="additionalFilters.includeCeased || additionalFilters.onlyCeased"
            (onValueChanged)="additionalFilterChanged('includeCeased', $event)"
          ></dx-check-box>
        </div>
      }
      @if (showDeletedToggle) {
        <div class="gv-additional-filters-item">
          <dx-check-box
            text="Include - Deleted"
            [disabled]="additionalFilters.onlyDeleted"
            [value]="additionalFilters.includeDeleted || additionalFilters.onlyDeleted"
            (onValueChanged)="additionalFilterChanged('includeDeleted', $event)"
          ></dx-check-box>
        </div>
      }
      @if (showCeasedFilters) {
        <div class="gv-additional-filters-item">
          <dx-check-box
            text="Show - Ceased"
            [value]="additionalFilters.onlyCeased"
            (onValueChanged)="additionalFilterChanged('onlyCeased', $event)"
          ></dx-check-box>
        </div>
      }
      @if (showDeletedToggle) {
        <div class="gv-additional-filters-item">
          <dx-check-box
            text="Show - Deleted"
            [value]="additionalFilters.onlyDeleted"
            (onValueChanged)="additionalFilterChanged('onlyDeleted', $event)"
          ></dx-check-box>
        </div>
      }
    </div>
  </dx-popup>
}

<ng-template #genericModalContent role="document" let-modal>
  <div
    class="modal-header custom-suresim-header p-3 d-flex align-items-center justify-content-between position-relative"
    [ngStyle]="{ 'background-color': titlesUseSureSimBlue ? '#47568C' : '#e9ecf1' }"
  >
    <div class="d-flex align-items-center gap-2">
      @if (titlesUseSureSimBlue && (!curUser.branded || curUser.isUtelize)) {
        <img
          alt="Logo"
          class="me-2"
          [height]="isPlatformModeInview ? 45 : 45"
          [src]="isPlatformModeInview ? 'assets/images/myinview-logo.png' : 'assets/images/SureSIM-Logo-Light-109.png'"
        >
      }
      
      <div class="d-flex align-items-center">
        <h4 class="modal-title mb-0 me-2" id="formTitle" style="position: relative; top: 3px;"
          [ngStyle]="{ 'color': titlesUseSureSimBlue ? 'white' : 'black' }"
        >
          {{dgPopup?.title}}
        </h4>
      </div>
    </div>
  
    <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3" data-bs-dismiss="modal"  aria-label="Close" id="close-modal" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <form (ngSubmit)="saveFormData()" [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @for(field of dgColumns; track field){
        @if(field.formEnabled)
        {
          @if(field.formVisible)
          {
            @if(field.dataType=="boolean") {
              <div class="mb-3">
                <!-- <div class="form-check form-switch form-switch-right form-switch-md"> -->
                <div class="form-check form-switch form-switch-md">
                  <label class="form-check-label" for="{{field.dataField}}-field">{{field.caption}}</label>
                  <input class="form-check-input" type="checkbox" role="switch" id="{{field.dataField}}-field" formControlName="{{field.dataField}}" checked>
                </div>
               <div *ngIf="formData[field.dataField].hasError('eitherOr')" class="invalid-feedback d-block text-start mt-1">
                 {{ formData[field.dataField].getError("eitherOr").message }}
               </div>
              </div>
            } @else if(field.dataType=="datalist") {
              <div class="mb-3">
                <label for="{{field.dataField}}-field" class="form-label">
                  {{ field.captionExtra ? (field.caption + ' ' + field.captionExtra) : field.caption }}
                </label>
                <input [attr.list]=field.dataField id="{{field.dataField}}-field" class="form-control" (focus)="clearDataList(field)" (change)="onSelect($event)" placeholder="" formControlName="{{field.dataField}}" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formData[field.dataField].errors }" />
                <datalist id="{{field.dataField}}"> 
                @for (object of getDropdownDataObjectArray(field.dataField); track object.description)
                  {
                  <option [value]="object.description">{{object.description}}</option>    
                  }
                </datalist> 
                @if(formData[field.dataField].hasError("minlength")) {
                  <div class="invalid-feedback">Minimum length has not been met</div>
                } @else if(formData[field.dataField].hasError("maxlength")) {
                  <div class="invalid-feedback">Maximum length has been exceeded</div>
                } @else {
                  <div class="invalid-feedback">A value is required</div>
                }
              </div>
            } @else if(field.dataSourceForAForm) {
              <div class="mb-3">
                <label for="{{field.dataField}}-field" class="form-label">
                  {{ field.captionExtra ? (field.caption + ' ' + field.captionExtra) : field.caption }}
                </label>
                @if (modalSearchableDropdowns) {
                  <ng-select
                    appendTo="body"
                    id="{{ field.dataField }}-field"
                    class="company-clean"
                    formControlName="{{ field.dataField }}"
                    [items]="getDropdownDataObjectArray(field.dataField)"
                    bindLabel="description"
                    bindValue="id"
                    [searchable]="true"
                    [clearable]="false"
                    [placeholder]="' '"
                    panelClass="dd-tall"
                    [readonly]="field.readOnly"
                    [class.is-invalid]="formSubmitted && formData[field.dataField].errors"
                    (change)="onDropdownChange($event, field.dataField)">
                  </ng-select>
                } @else {
                  <select
                    class="form-select"
                    name="{{field.dataField}}-field"
                    id="{{field.dataField}}-field"
                    formControlName="{{field.dataField}}"
                    [attr.disabled]="field.readOnly ? true : null"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData[field.dataField].errors }"
                    (change)="onDropdownChange($event, field.dataField)"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray(field.dataField); track object.id)
                    {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                }
                @if(formData[field.dataField].hasError("mandatoryWhenComponentXSet")) {
                  <div class="invalid-feedback d-block text-start mt-1">{{ formData[field.dataField].getError("mandatoryWhenComponentXSet").message }}</div>
                } @else if(formData[field.dataField].hasError('required')) {
                  <div class="invalid-feedback">A value is required</div>
                }
              </div>
            } @else if (field.dataType=="date") {
              <div class="mb-3">
                <app-dropdown-date
                id="{{field.dataField}}-field"
                [dateFormat]="dateFormat(field)"
                [disable]="field.readOnly"
                [allowUndefinedInitialDate]="true"
                [initialDate]="field.ourDate"
                [monthSelector]="monthSelector(field)"
                [yearSelector]="yearSelector(field)"
                title="{{ field.captionExtra
                          ? field.caption + ' ' + field.captionExtra
                          : field.caption }}"
                (clearedEvent)="dateSelectionCleared(field.dataField)"
                (selectOnChangeEvent)="dateSelectionChanged($event,field.dataField)"
                ></app-dropdown-date>
              </div>
            } @else {
              <div class="mb-3">
                <label for="{{field.dataField}}-field" class="form-label">
                  {{ field.captionExtra ? (field.caption + ' ' + field.captionExtra) : field.caption }}
                </label>
                <input
                  class="form-control"
                  data-lpignore="true"
                  formControlName="{{field.dataField}}"
                  id="{{field.dataField}}-field"
                  [ngClass]="{ 'is-invalid': formSubmitted && formData[field.dataField].errors }"
                  [placeholder]="field.placeholder ? field.placeholder : ''"
                  type="text"
                />
                @if(formData[field.dataField].hasError("minlength")) {
                  <div class="invalid-feedback">Minimum length has not been met</div>
                } @else if(formData[field.dataField].hasError("maxlength")) {
                  <div class="invalid-feedback">Maximum length has been exceeded</div>
                } @else if(formData[field.dataField].hasError("invalidURL")) {
                  <div class="invalid-feedback">Invalid URL</div>
                } @else if(formData[field.dataField].hasError("mandatoryWhenComponentXSet")) {
                  <div class="invalid-feedback d-block text-start mt-1">{{ formData[field.dataField].getError("mandatoryWhenComponentXSet").message }}</div>
                } @else if(formData[field.dataField].hasError("valueInvalidForParam")) {
                  <div class="invalid-feedback d-block text-start mt-1">{{ formData[field.dataField].getError("valueInvalidForParam").message }}</div>
                } @else if(formData[field.dataField].hasError('required')) {
                  <div class="invalid-feedback">A value is required</div>
                }
              </div>
            }
          } @else {
            <input type="hidden" name="{{field.dataField}}-field" value="" formControlName="{{field.dataField}}" />
          }
        }
      }
    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 w-100">
        <span class="form-text me-auto">{{dgPopup?.footerText}}</span>
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="resetForm(false)" (click)="modal.close('Close click')">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">@if(formData['id'].value && formData['id'].value>0){Update}@else{Add}</button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #deleteModel let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#405189,secondary:#f06548" style="width:90px;height:90px"></lord-icon>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you sure you want to delete the selected record?</h4>
          <p class="text-muted mx-4 mb-0">WARNING - This action cannot be undone</p>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button class="btn btn-link link-success fw-medium text-decoration-none" data-bs-dismiss="modal" (click)="modal.close('Close click')"><i class="ri-close-line me-1 align-middle"></i>No</button>
        <button type="button" class="btn w-sm btn-danger " id="delete-product" (click)="deleteData(deleteId)" (click)="modal.close('Close click')">Yes, Delete It!</button>
      </div>
    </div>
  </div>
</ng-template>
